export default __webpack_public_path__ + "static/media/sharpsans-bold.82ecdac1.otf";